export const GET_DASHBOARD_OFFICE = "office/getDashboardOffice";
